<app-header [transparent]="transparent" />
<div class="ourevent">
    <ng-container *ngFor="let heading of head">
        <div class="ourevent_top text-center  bg_1 inline_padding2 bg_img" *ngIf="heading.page === currentPage">
            <div>
                <span class="text_style_5">Our Events</span>
            </div>
            <div class="p-top-16">
                <span class="text_style_1" [innerHTML]="heading.page_sub_heading"></span>
            </div>
        </div>
    </ng-container>
    <div class="ourevent_content">
        <div class="ourevent_content_box">
            <ng-container *ngFor="let event of eventsList">
                <div class="ourevent_content_box_item z_index_1">
                    <div class="height-600 card_1 ">
                        <div class="card_1_img">
                            <img height="100%" width="100%" [src]="getEventImageUrl(event.event_poster)" alt="img"
                                class="object-fill border-radius-20" />
                        </div>
                        <div class="card_1_content">
                            <div class="card_1_content_top">
                                <div *ngIf="event.event_start_date === event.event_end_date; else differentDates">
                                    <div class="card_1_content_top_date">
                                        <div class="text_blue_9 line-height-36">{{ event.event_start_date | date:'dd' }}
                                        </div>
                                        <div class="text_black_4_res line-height-19">{{ event.event_start_date |
                                            date:'MMM' }}</div>
                                        <div class="text_black_4_res line-height-19">{{ event.event_start_date |
                                            date:'yyyy' }}</div>
                                    </div>
                                </div>

                                <ng-template #differentDates>
                                    <div class="card_1_content_top_date">
                                        <div class="text_black_4_res ">{{ event.event_start_date| date:'dd MMM yyyy' }}
                                        </div>
                                        <div class="text_blue_6">to</div>
                                        <div class="text_black_4_res ">{{ event.event_end_date | date:'dd MMM yyyy'}}
                                        </div>
                                    </div>
                                </ng-template>

                                <div class="card_1_content_top_logo">
                                    <img [src]="getLogoImageUrl(event.event_logo)"
                                        class="width-100-per height-100-per object-fit" />
                                </div>
                            </div>
                            <div class="card_1_content_middle">
                                <div class="card_1_content_middle_title text_lines_2">
                                    <span class="text_black_1_res">{{event.event_name}}</span>
                                </div>
                                <div class="card_1_content_middle_normal">
                                    <div>
                                        <svg width="12" height="16" viewBox="0 0 12 16" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M6 0C2.68811 0.00439329 0.0043933 2.68811 0 6C0 10.3075 5.59 15.7025 5.8275 15.93C5.92355 16.0233 6.07645 16.0233 6.1725 15.93C6.41 15.7025 12 10.3075 12 6C11.9956 2.68811 9.31189 0.00439329 6 0ZM6 8.75C4.48122 8.75 3.25 7.51877 3.25 5.99999C3.25 4.48121 4.48122 3.25 6 3.25C7.51878 3.25 8.75 4.48121 8.75 5.99999C8.74909 7.5184 7.51841 8.74908 6 8.75Z"
                                                fill="#0032A0" />
                                        </svg>
                                    </div>
                                    <div class="text_lines_2">
                                        <span class="text_black_3_res">{{event.event_address}}</span>
                                    </div>
                                </div>
                                <div class="card_1_content_middle_normal">
                                    <div>
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_2277_7807)">
                                                <path
                                                    d="M7 0C3.14005 0 0 3.14005 0 7C0 10.86 3.14005 14 7 14C10.86 14 14 10.86 14 7C14 3.14005 10.86 0 7 0ZM10.3291 10.6207C10.2153 10.7345 10.066 10.7917 9.9167 10.7917C9.76738 10.7917 9.61795 10.7345 9.5043 10.6207L6.5876 7.7041C6.47791 7.59505 6.4167 7.44679 6.4167 7.2917V3.5C6.4167 3.17743 6.67796 2.9167 7 2.9167C7.32204 2.9167 7.5833 3.17743 7.5833 3.5V7.0502L10.3291 9.7959C10.5571 10.024 10.5571 10.3927 10.3291 10.6207Z"
                                                    fill="#0032A0" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_2277_7807">
                                                    <rect width="14" height="14" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <span class="text_black_3_res">{{event.event_start_time}} -
                                        {{event.event_end_time}}</span>
                                </div>
                            </div>
                            <div class="card_1_content_bottom">
                                <button type="button" class="rounded-pill text_white_1 button_blue_1"
                                    (click)="goToEventDetails(event.id || event._id)"><span
                                        class="button_blue_1_text">View More</span> <img class="button_blue_1_text_icon"
                                        src="../../../assets/icons/arrow-right.png" /></button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <!-- <div class="ourevent_row">

        <div class="ourevent_row_head">
            <p class="ourevent_row_head_title text_style_5">Our Events</p>
            <p class="ourevent_row_head_description text_style_1 ">Lorem ipsum dolor sit amet, consectetur adipiscing
                elit, sed do eiusmod tempor incididunt ut labore et dolore magna</p>
        </div>
    </div> -->
    <!-- <div class="ourevent_row">
        <div class="ourevent_row_box">
            <div class="ourevent_row_box_cards">
                <ng-container *ngFor="let card of EventCards">

                    <div class="ourevent_row_box_cards_card">
                        <div class="ourevent_row_box_cards_card_img">
                            <img class="ourevent_row_box_cards_card_img_back"
                                src="assets/img/event_bgimg/bg_img1.png" />

                            <span class="ourevent_row_box_cards_card_img_leftimg">
                                <li class="ourevent_row_box_cards_card_img_leftimg_date text_blue_3">23</li>
                                <li class="ourevent_row_box_cards_card_img_leftimg_month text_style_1">Jan</li>
                                <li class="ourevent_row_box_cards_card_img_leftimg_year text_style_1">2024</li>
                            </span>
                            <div class="ourevent_row_box_cards_card_img_rightimg"><img
                                    src="assets/img/ample-ebusiness-logo-new1.png" /></div>
                        </div>
                        <div class="ourevent_row_box_cards_card_body">
                            <p class="ourevent_row_box_cards_card_body_heading text_black_3">Standards and
                                Scientific
                                Advice on Food and Nutrition</p>
                            <p class="ourevent_row_box_cards_card_body_address text_black_4">E-15, Block E, East
                                of
                                Kailash, New Delhi, Delhi 110065, India</p>
                            <p class="ourevent_row_box_cards_card_body_time text_black_4">08:00am - 05:00pm</p>

                            <a href="#" class="btn btn-primary text_white_1 ourevent_row_box_cards_card_btn">View
                                Detail<img class="ourevent_row_box_cards_card_btn_arrow"
                                    src="assets/img/right-arrow 1.png"></a>


                        </div>
                    </div>

                </ng-container>
            </div>
        </div>
    </div> -->
</div>
<app-footer />